import * as types from '../../../actions'; 

const initialState = {
  keyLocationsList: [],
  departmentsList: [],
  departmentData: [],
  status:0,
  activity:'',
  affiliateDeptActivity:'',
  affiliateDepartmentsList: [],
  errorData:''    
};

export default function(state = initialState, action) {
    const response = action.response; 
    let timeVar = '~~'+Date.now(); 
    
    switch(action.type) {
        // ************** KEY_LOC_LIST_AFFILIATE *********************
        case types.KEY_LOC_LIST_AFFILIATE_SUCCESS: 
            if(response.status===200){
                return {
                    ...state,
                    keyLocationsList: response.data,
                    departmentsList: [...state.departmentsList],
                    departmentData: [...state.departmentData],
                    status: response.status,
                    activity: types.KEY_LOC_LIST_AFFILIATE_SUCCESS+timeVar
                };
            }
            else{
                return { ...state, status: response.status,    
                    activity: types.SKILL_LIST_AFFILIATE_ERROR+timeVar                             
                };
            }        
        case types.KEY_LOC_LIST_AFFILIATE_ERROR:
            // return { ...state, response };
            return { ...state, status: response.status,    
                activity: types.SKILL_LIST_AFFILIATE_ERROR+timeVar                             
            };


        // ************** DEPARTMENT_LIST_AFFILIATE *********************
        case types.DEPARTMENT_LIST_AFFILIATE_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    keyLocationsList: [...state.keyLocationsList],
                    departmentsList: response.data,
                    departmentData: [...state.departmentData],
                    status: response.status,
                    activity:types.DEPARTMENT_LIST_AFFILIATE_SUCCESS+timeVar,
                    affiliateDeptActivity: types.DEPARTMENT_LIST_AFFILIATE_SUCCESS+timeVar,
                    affiliateDepartmentsList: response.data,
                };
            }
            else{
                return { ...state, response, status: response.status,    
                    activity: types.DEPARTMENT_LIST_AFFILIATE_ERROR+timeVar                             
                };
            }  
        case types.DEPARTMENT_LIST_AFFILIATE_ERROR:
            return { ...state, response, status: response.status,    
                activity: types.DEPARTMENT_LIST_AFFILIATE_ERROR+timeVar                             
            }; 


        // ************** DEPARTMENT_ADD_AFFILIATE *********************
        case types.DEPARTMENT_ADD_AFFILIATE_SUCCESS: 
            if(response.status===200 || response.status===201){
                return {
                ...state,
                keyLocationsList: [...state.keyLocationsList],
                departmentsList: [...state.departmentsList],
                departmentData: [...state.departmentData],
                status: response.status,
                activity:types.DEPARTMENT_ADD_AFFILIATE_SUCCESS+timeVar
                };
            }
            else{
                return { ...state, response, status: response.status,    
                    activity: types.DEPARTMENT_ADD_AFFILIATE_ERROR+timeVar,
                    errorData: response.data,                               
                };
            }      
        case types.DEPARTMENT_ADD_AFFILIATE_ERROR:
            return { ...state, response, status: response.status,    
                activity: types.DEPARTMENT_ADD_AFFILIATE_ERROR+timeVar                             
            };   
 

        // ************** DEPARTMENT_UPDATE_AFFILIATE *********************
        case types.DEPARTMENT_UPDATE_AFFILIATE_SUCCESS: 
            if(response.status===200){
                return {
                    ...state,
                    keyLocationsList: [...state.keyLocationsList],
                    departmentsList: state.departmentsList.map(item => {
                        return item.id === response.data.id ? response.data : item;
                    }),
                    departmentData: [...state.departmentData],
                    status: response.status,
                    activity:types.DEPARTMENT_UPDATE_AFFILIATE_SUCCESS+timeVar
                };
            }
            else{
                return { ...state, response, status: response.status,    
                    activity: types.DEPARTMENT_UPDATE_AFFILIATE_ERROR+timeVar,
                    errorData: response.data,                              
                };
            }     
        case types.DEPARTMENT_UPDATE_AFFILIATE_ERROR:
            return { ...state, response, status: response.status,    
                activity: types.DEPARTMENT_UPDATE_AFFILIATE_ERROR+timeVar                             
            };   

        
        // ************** DEPARTMENT_DELETE_AFFILIATE *********************    
        case types.DEPARTMENT_DELETE_AFFILIATE_SUCCESS:
            const delId = response.data.id;          
            if(response.status===200 || response.status===204){
                return {
                    keyLocationsList: [...state.keyLocationsList],
                    departmentsList: state.departmentsList.filter(items => items.id !== delId), 
                    departmentData: [...state.departmentData],
                    status: response.status,
                    activity:types.DEPARTMENT_DELETE_AFFILIATE_SUCCESS+timeVar
                };
            }
            else{
                return { ...state, response, status: response.status,    
                    activity: types.DEPARTMENT_DELETE_AFFILIATE_ERROR+timeVar,
                    errorData: response.data,                               
                };
            }     
        case types.DEPARTMENT_DELETE_AFFILIATE_ERROR:
            return { ...state, response, status: response.status,    
                activity: types.DEPARTMENT_DELETE_AFFILIATE_ERROR+timeVar                             
            };    


        // ************** CLEAR *********************    
        case types.CLEAR:
            return {
                ...state,
                item:{ id:'', name: '', },
                activity:'',
                status:0               
            }  


        default:
            return state;

  }
};
